export default __webpack_public_path__ + "static/media/cronos.6413014c.svg";